var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"image-previewer",on:{"click":function($event){return _vm.clickFunc()}}},[_c('img',{attrs:{"width":"40","height":"40","src":_vm.resolvedImg,"alt":"Preview Image"}}),_vm._v(" "),_c('article',[_c('img',{attrs:{"src":_vm.resolvedImg,"alt":"Previewed Image"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4a7cd3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/ImagePreviewer.vue
// module id = null
// module chunks = 